import { withInstall } from '@ll-plus/utils'

import SortSelector from './src/sort-selector.vue'

export const LlSortSelector = withInstall(SortSelector)
export default LlSortSelector
export * from './src/sort-selector'

declare module 'vue' {
  export interface GlobalComponents {
    LlSortSelector: typeof SortSelector
  }
}
